import { render, staticRenderFns } from "./MainCourseTable.vue?vue&type=template&id=29a99649&"
import script from "./MainCourseTable.vue?vue&type=script&lang=js&"
export * from "./MainCourseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports